import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Travelagentsinpune() {



const cardData = {
  keyword: " Travel Agents in Pune",

"headingDescription": "SRS Cab Service provides trusted Travel Agents in Pune, offering complete travel solutions including cab bookings, tour packages, hotel arrangements, and customized itineraries. With experienced travel planners, well-maintained vehicles, and professional drivers, we ensure a smooth and hassle-free travel experience for families, corporate clients, and tourists. Whether it's local sightseeing, outstation trips, or holiday planning, SRS Cab Service delivers flexible packages, transparent pricing, and 24/7 customer support to make your journey convenient and memorable.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort and one of Pune’s most iconic landmarks. Travelers using Travel Agents in Pune from SRS Cab Service often include this site in their itinerary to explore the city’s rich history."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a significant historical monument associated with India’s freedom movement. Visitors using SRS Cab Service often visit to admire its architecture and peaceful surroundings."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a popular hill fort known for scenic views and trekking. Travelers using SRS Cab Service often include this destination for adventure and sightseeing."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered temples. Visitors using SRS Cab Service often visit to seek blessings and experience spiritual peace."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva. Travelers using SRS Cab Service often explore this peaceful and historic site."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum showcases a vast collection of Indian artifacts. Visitors using SRS Cab Service often explore Pune’s cultural heritage here."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple offers panoramic views of Pune along with historic temples. Travelers using SRS Cab Service often visit for sightseeing and relaxation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a serene destination surrounded by nature. Visitors using SRS Cab Service often include this spot for leisure and photography."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden is a beautifully landscaped Japanese garden. Travelers using SRS Cab Service often enjoy its peaceful ambiance and greenery."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic palace associated with Chhatrapati Shivaji Maharaj. Visitors using SRS Cab Service often explore this landmark to learn about Pune’s heritage."
  }
],



services: [
{
name: "Travel Agents in Pune",
description: "Travel agents in Pune provide complete travel solutions for local and outstation trips. Customers can book tours, cabs, and packages easily. Professional agents ensure smooth travel planning. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with trusted travel agents in Pune."
},
{
name: "Travel Agency in Pune for Car",
description: "Travel agency in Pune for car offers reliable cab booking services for all travel needs. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with car rental agencies."
},
{
name: "Best Travel Agencies in Pune",
description: "Best travel agencies in Pune offer top-rated services for tours and cab bookings. Customers can enjoy complete travel solutions. Professional staff ensure smooth planning. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with the best agencies in Pune."
},
{
name: "Pune Best Travel Agency",
description: "Pune best travel agency provides premium travel services for all destinations. Customers can book cabs and tour packages easily. Professional agents ensure smooth travel experience. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with top travel agencies."
},
{
name: "Pune Tours and Travels Agents",
description: "Pune tours and travels agents offer complete travel planning for local and outstation trips. Customers can book packages and cabs easily. Professional agents ensure safe travel arrangements. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with travel agents."
},
{
name: "Tour Agencies in Pune",
description: "Tour agencies in Pune provide organized travel solutions for vacations and business trips. Customers can book tours and packages easily. Professional staff ensure smooth travel planning. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with tour agencies."
},
{
name: "Tourist Agency in Pune",
description: "Tourist agency in Pune offers travel solutions for sightseeing and holiday trips. Customers can book cabs and tour packages easily. Professional agents ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with tourist agencies."
},
{
name: "Travel Agents in Kothrud",
description: "Travel agents in Kothrud provide reliable travel services for local residents. Customers can book cabs and tours easily. Professional agents ensure smooth planning. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with travel agents in Kothrud."
},
{
name: "Travel Agents in Hadapsar Pune",
description: "Travel agents in Hadapsar Pune offer convenient travel solutions for city and outstation trips. Customers can book cabs and packages easily. Professional agents ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with travel agents."
},
{
name: "Travel Agents in Viman Nagar",
description: "Travel agents in Viman Nagar provide premium travel services for corporate and personal needs. Customers can book cabs and tours easily. Professional agents ensure smooth travel planning. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with travel agents."
},
{
name: "Travel Agents in Kharadi",
description: "Travel agents in Kharadi offer reliable travel solutions for IT professionals and residents. Customers can book cabs and packages easily. Professional agents ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with travel agents."
},
{
name: "Travel Agency in Kharadi Pune",
description: "Travel agency in Kharadi Pune provides convenient booking services for local and outstation travel. Customers can book cabs and tours easily. Professional agents ensure smooth planning. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with agencies."
},
{
name: "Travel Agency in Viman Nagar Pune",
description: "Travel agency in Viman Nagar Pune offers premium travel services for airport and corporate travel. Customers can book cabs and tours easily. Professional agents ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with agencies."
},
{
name: "Travel Agents in Vadgaon Sheri Pune",
description: "Travel agents in Vadgaon Sheri Pune provide reliable travel services for local residents. Customers can book cabs and tours easily. Professional agents ensure smooth planning. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with travel agents."
},
{
name: "Travel Agents in Wagholi Pune",
description: "Travel agents in Wagholi Pune offer convenient travel solutions for city and outstation trips. Customers can book cabs and packages easily. Professional agents ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with travel agents."
},
{
name: "Travel Agents in Pune Airport",
description: "Travel agents in Pune airport provide reliable airport transfer and travel services. Customers can book cabs and tours easily. Professional agents ensure punctual travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport travel agents."
},
{
name: "Travel Agents in Baner Aundh Pune",
description: "Travel agents in Baner Aundh Pune offer premium travel services for corporate and residential areas. Customers can book cabs and packages easily. Professional agents ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with travel agents."
},
{
name: "Travel Agents in Koregaon Park",
description: "Travel agents in Koregaon Park provide luxury travel services for premium customers. Users can book cabs and tours easily. Professional agents ensure smooth planning. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with travel agents."
},
{
name: "Travel Agents in Wanwadi Pune",
description: "Travel agents in Wanwadi Pune offer reliable travel services for local and outstation trips. Customers can book cabs and packages easily. Professional agents ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with travel agents."
},
{
name: "Innova Cab Pune to Gujarat",
description: "Innova cab Pune to Gujarat offers comfortable SUV travel for long-distance trips. Customers can enjoy spacious seating and luggage space. Professional drivers ensure safe journeys. Ideal for family travel. Transparent pricing ensures value for money. Travel comfortably with Innova cab services."
},
{
name: "Innova Crysta Cab Pune to Gujarat",
description: "Innova Crysta cab Pune to Gujarat provides premium travel experience for long routes. Customers can enjoy luxury seating and comfort. Professional drivers ensure safe journeys. Ideal for corporate and family travel. Transparent pricing ensures value. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Cab Pune to Gujarat",
description: "Ertiga cab Pune to Gujarat offers comfortable 7 seater travel for families. Customers can book vehicles for long-distance trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
},
{
name: "Dzire Cab Pune to Gujarat",
description: "Dzire cab Pune to Gujarat provides budget-friendly travel for long-distance journeys. Customers can book vehicles for economical trips. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "Sedan Cab Pune to Gujarat",
description: "Sedan cab Pune to Gujarat offers affordable travel for individuals and small groups. Customers can book vehicles for long-distance trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "SUV Cab Pune to Gujarat",
description: "SUV cab Pune to Gujarat provides spacious and comfortable travel for long journeys. Customers can book SUVs for family trips. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with SUV cab services."
},
{
name: "Luxury Cab Pune to Gujarat",
description: "Luxury cab Pune to Gujarat offers premium travel experience for long-distance trips. Customers can enjoy high-end vehicles with comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel comfortably with luxury cab services."
}
],

tableData: [
["Travel Agents in Pune","Travel Agency in Pune for Car"],
["Best Travel Agencies in Pune","Pune Best Travel Agency"],
["Pune Tours and Travels Agents","Tour Agencies in Pune"],
["Tourist Agency in Pune","Travel Agents in Kothrud"],
["Travel Agents in Hadapsar Pune","Travel Agents in Viman Nagar"],
["Travel Agents in Kharadi","Travel Agency in Kharadi Pune"],
["Travel Agency in Viman Nagar Pune","Travel Agents in Vadgaon Sheri Pune"],
["Travel Agents in Wagholi Pune","Travel Agents in Pune Airport"],
["Travel Agents in Baner Aundh Pune","Travel Agents in Koregaon Park"],
["Travel Agents in Wanwadi Pune","Innova Cab Pune to Gujarat"],
["Innova Crysta Cab Pune to Gujarat","Ertiga Cab Pune to Gujarat"],
["Dzire Cab Pune to Gujarat","Sedan Cab Pune to Gujarat"],
["SUV Cab Pune to Gujarat","Luxury Cab Pune to Gujarat"]
],



whychoose: [
  {
    WhyChooseheading: "Wide Range of Travel Packages",
    WhyChoosedescription: "Travel agents in Pune offer domestic, international, honeymoon, pilgrimage, and corporate tour packages tailored to different travel needs."
  },
  {
    WhyChooseheading: "Customized Travel Planning",
    WhyChoosedescription: "Professional travel agents design personalized itineraries based on your budget, preferences, and travel duration for a hassle-free experience."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "Most travel agencies in Pune provide competitive pricing with clear cost breakdowns, ensuring no hidden charges in tour packages."
  },
  {
    WhyChooseheading: "Flight, Hotel & Visa Assistance",
    WhyChoosedescription: "Travel agents handle complete travel arrangements including flight bookings, hotel reservations, visa processing, and travel insurance."
  },
  {
    WhyChooseheading: "24/7 Customer Support",
    WhyChoosedescription: "Top travel agencies offer round-the-clock support for bookings, cancellations, and emergency assistance during your trip."
  },
  {
    WhyChooseheading: "Expert Destination Knowledge",
    WhyChoosedescription: "Travel agents provide expert guidance on destinations, best travel time, sightseeing, and local experiences for a better journey."
  },
  {
    WhyChooseheading: "Group Tours & Corporate Travel",
    WhyChoosedescription: "Many agencies specialize in group tours, employee travel, and corporate event planning with dedicated travel management services."
  },
  {
    WhyChooseheading: "Trusted & Reliable Services",
    WhyChoosedescription: "Established travel agents in Pune are known for reliable service, customer satisfaction, and well-organized travel experiences."
  }
]
}

const faqData = [
  { question: "Which are the best travel agents in Pune?", answer: "Top travel agents include Veena World, Girikand Travels, Traveazy Group, Maya Holidays, and Thomas Cook India." },
  { question: "What services do travel agents in Pune provide?", answer: "They offer tour packages, flight booking, hotel booking, visa assistance, travel insurance, and customized travel planning." },
  { question: "Are travel agents in Pune affordable?", answer: "Yes, most agencies offer budget-friendly packages along with premium options depending on travel needs." },
  { question: "Do travel agents provide international tours?", answer: "Yes, many Pune-based agencies offer international tour packages with visa and documentation support." },
  { question: "Can I get customized travel packages?", answer: "Yes, travel agents provide customized itineraries based on your preferences and budget." },
  { question: "Do travel agents provide group tours?", answer: "Yes, group tours, corporate tours, and family packages are commonly offered." },
  { question: "Is online booking available?", answer: "Yes, most travel agencies provide online booking and consultation services." },
  { question: "Do they offer pilgrimage tours?", answer: "Yes, many agencies offer pilgrimage packages like Char Dham, Jyotirlinga, and Ashtavinayak tours." },
  { question: "Are travel agents reliable?", answer: "Reputed travel agents in Pune are reliable and provide professional travel services." },
  { question: "Do they provide support during travel?", answer: "Yes, many agencies offer 24/7 support during your trip." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Joshi",
    feedback:
      "Booked my Kashmir trip through a Pune travel agent. Everything was perfectly planned and hassle-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Kulkarni",
    feedback:
      "Best travel agency experience in Pune. Affordable package and excellent customer support.",
    rating: 5
  }
];




























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "TravelAgency",
  "name": "SRS Cab & Tours - Travel Agents in Pune",
  "description": "Book with the best travel agents in Pune. Offering car rentals, tour packages, and travel planning in Kothrud, Hadapsar, Viman Nagar, Kharadi, Baner, Aundh, Koregaon Park, Wagholi, and Pune Airport area.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/travel-agents-in-pune",
  "openingHours": "Mo-Su 09:00-21:00",
  "areaServed": [
    "Kothrud, Pune",
    "Hadapsar, Pune",
    "Viman Nagar, Pune",
    "Kharadi, Pune",
    "Baner, Pune",
    "Aundh, Pune",
    "Koregaon Park, Pune",
    "Wagholi, Pune",
    "Pune Airport"
  ],
  "priceRange": "₹₹₹",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1245"
  }
};








  return (
    <div>
      <Helmet>
  <title>Best Travel Agents in Pune | SRS Cab & Tours</title>
  <meta 
    name="description" 
    content="Find trusted travel agents in Pune for car rentals, tour packages, and travel planning. Serving Kothrud, Hadapsar, Viman Nagar, Kharadi, Baner, Aundh, Koregaon Park, Wagholi & Pune Airport." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/54.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Travelagentsinpune;